var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import { PureMasthead as Masthead } from './index';
import { json } from 'd3-request';
import { parseHostname } from '@ta-interaktiv/parse-hostname';
import setFavicon from 'favicon-setter';

import { Helmet } from 'react-helmet';
import { Paywall as TamediaPaywall } from '@ta-interaktiv/react-paywall';
import Tracking from '@ta-interaktiv/react-tracking';
import { defaultClickHandler } from '@ta-interaktiv/react-share-buttons';

/**
 * Enum states for the loading process.
 * @private
 * @type {{LOADING: string, ERROR: string, READY: string}}
 */
var requestState = {
  LOADING: 'loading',
  ERROR: 'error',
  READY: 'ready'

  /**
   * API endpoint subdomain for the Newsnet API
   * @private
   * @type {string}
   */
};var API_ENDPOINT = 'm';

/**
 * Display the masthead in standalone projects. Adapts to the tenant.
 *
 * @example
 * import Masthead from '@ta-interaktiv/react-polymorphic-masthead';
 *
 * // more code ...
 *
 * class YourComponent extends React.Component {
 *  render() {
 *
 *    return (
 *      <Masthead articleId='346234' hashtags={['TAGrafik', 'DDJ']} />
 *    )
 *  }
 * }
 *
 * @param {object} props
 * @param {string} props.articleId The article ID of the main / link article
 *   in the CD. Used to get the appropriate share URLs and counts. This was
 *   previously called articleID. This change should be backwards compatible.
 * @param {boolean} [props.inverted=false] Displays the masthead transparent
 *   with white text for dark backgrounds.
 * @param {string[]} [props.hashtags] Hashtags as an array of strings.
 *   Facebook will only use the first one.
 * @param {function} [props.clickHandler=clickHandler] An
 *   action to execute when the button is clicked. Defaults to a call to the
 *   share button counter API endpoint.
 * @param {number} [props.additionalFacebookShares] A number that can make
 * up for lost Facebook shares that have been lost due to a change of the
 * canonical URL.
 * @param {React.Node} [props.children] Additional content for the middle column
 * @param {boolean} [props.enablePaywall=true] - Whether the paywall should
 * be enabled.
 * @param {string} [props.paywallContainerId] - The ID of the DOM element that
 * should contain the paywall elements.
 * @param {string} [props.defaultLanguage=de] - The default language this
 * document is in. If the request to the Newsnet API is successful, this
 * will be changed according to the setting there.
 */
export var PolymorphicMasthead = function (_React$PureComponent) {
  _inherits(PolymorphicMasthead, _React$PureComponent);

  function PolymorphicMasthead(props) {
    _classCallCheck(this, PolymorphicMasthead);

    var _this = _possibleConstructorReturn(this, (PolymorphicMasthead.__proto__ || Object.getPrototypeOf(PolymorphicMasthead)).call(this, props));

    _this.parsedHostname = parseHostname();
    _this.state = {
      language: _this.props.defaultLanguage,
      loadingState: 'loading',
      clickHandler: _this.props.clickHandler,
      homepage: '//www.' + _this.parsedHostname.publicationDomain,
      mediaName: _this.parsedHostname.publicationName,
      url: window.location.href,
      fullMediaName: '',
      title: window.document.title.toString(),
      paywallConfiguration: {},
      paywallStatus: 0
    };


    _this.articleId = _this.props.articleId === undefined ? _this.props.articleID : _this.props.articleId;

    // Show deprecation warning when using articleID
    if (_this.props.articleID !== undefined) {
      console.group('@ta-interaktiv/react-masthead');
      console.warn('Please use the "articleId" prop instead of "articleID".');
      console.groupEnd();
    }
    return _this;
  }

  _createClass(PolymorphicMasthead, [{
    key: 'render',
    value: function render() {
      if (this.state.loadingState === requestState.LOADING) {
        // preliminarily show the masthead, so we don't get a flash of
        // non-mastheaded content
        return React.createElement(
          Masthead,
          _extends({}, this.props, this.state),
          this.props.children
        );
      }

      return React.createElement(
        Masthead,
        _extends({}, this.props, this.state),
        ' ',
        React.createElement(
          Helmet,
          {
            titleTemplate: '%s ' + (this.state.fullMediaName ? '| ' + this.state.fullMediaName : '')
          },
          React.createElement('html', { lang: this.state.language + '-CH' }),
          React.createElement('link', {
            rel: 'canonical',
            href: this.state.homepage + '/' + this.articleId
          }),
          React.createElement('meta', {
            property: 'og:url',
            content: this.state.homepage + '/' + this.articleId
          }),
          React.createElement(
            'title',
            null,
            this.state.title
          )
        ),
        ' ',
        this.props.enablePaywall && this.state.loadingState === requestState.READY && this.state.paywallConfiguration && React.createElement(TamediaPaywall, {
          isEnabled: this.props.enablePaywall,
          paywallContainerId: this.props.paywallContainerId,
          paywallConfiguration: this.state.paywallConfiguration,
          paywallStatus: this.state.paywallStatus
        }),
        ' ',
        this.state.loadingState === requestState.READY && this.state.statistics && React.createElement(Tracking, {
          gtmId: this.state.gtmId,
          statisticsConfigs: this.state.statistics
        }),
        ' ',
        this.props.children
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // set favicon based on medium, works in Chrome, Firefox, Opera
      setFavicon('//www.' + this.parsedHostname.publicationName + '.ch/favicon.ico');

      json('//' + API_ENDPOINT + '.' + this.parsedHostname.publicationDomain + '/api/articles/' + this.articleId + '/external_services', function (error, data) {
        if (error) {
          console.group('@ta-interaktiv/react-masthead');
          console.warn('Error while loading article data. Default or implied' + ' values will be used.');
          console.groupEnd();

          _this2.setState({
            loadingState: requestState.ERROR,
            clickHandler: function clickHandler() {}, // no-op when there is an obvious problem
            paywallStatus: 0
          });
          return;
        }

        _this2.setState({
          loadingState: requestState.READY,
          communities: data.communities,
          fullMediaName: data.configs.name,
          language: data.configs.language,
          clickHandler: _this2.props.clickHandler.bind(null, _this2.articleId),
          paywallConfiguration: data.paywall,
          paywallStatus: data.configs.paywall_status,
          gtmId: data.configs.gtm_id,
          statistics: data.statistics
        });
      });
    }
  }]);

  return PolymorphicMasthead;
}(React.PureComponent);

PolymorphicMasthead.defaultProps = {
  clickHandler: defaultClickHandler,
  enablePaywall: true,
  defaultLanguage: 'de'
};
export default PolymorphicMasthead;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-masthead/es/polymorphicMasthead.js
// module id = 35
// module chunks = 0